// Social Links
export const linkedinLink = "https://www.linkedin.com/in/sanjampreetsingh/";
export const twitterLink = "https://twitter.com/sanjampreet_";
export const youtubeLink = "https://www.youtube.com/@sanjampreet-singh/";
export const instagramLink = "https://www.instagram.com/coach_sanjam/";
export const githubLink = "https://github.com/SanjampreetSingh/";
// Organization Links
export const bcgXLink = "https://www.bcg.com/x";
export const accentureLink = "https://www.accenture.com/in-en";
export const infosysLink = "https://www.infosys.com/";
// Personal Links
export const gndecLink = "https://www.gndec.ac.in/";
export const emailLink = "sanjam531@gmail.com";
export const resumeLink =
  "https://drive.google.com/file/d/1Fp3D9jq8EFG69IdxE8LpP7zRFdrvQTd_/view?usp=sharing";
//  YouTube Channel Links
export const mainChannelYTLink = "https://www.youtube.com/@sanjampreet-singh/";
export const kirtanChannelYTLink = "https://www.youtube.com/@SanjampreetSingh/";
export const codingChannelYTLink = "https://www.youtube.com/@CodeSanjam";
// Dev.to API
export const devToAPI =
  "https://dev.to/api/articles/?username=sanjampreetsingh&state=all";
// Call to action link
export const callToActionLink = "https://forms.gle/hC7569jreZFAU7856";
